import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { I2faResponse, I2faType } from 'pod-ng-core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-set-2fa',
  templateUrl: './set-2fa.component.html',
})
export class Set2faComponent implements OnInit {
  private sub: Subscription;

  public token: string;
  public type: I2faType;

  public I2faType = I2faType;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  public ngOnInit() {
    this.sub = this.activatedRoute.params.subscribe(params => {
      if (!Object.values(I2faType).includes(params.type)) {
        this.router.navigate(['/']);
        return;
      }

      this.type = params.type;
      this.token = params.token;
    });
  }

  public handleSubmit(result: I2faResponse) {
    const returnUrl = this.activatedRoute.snapshot.queryParams.returnUrl || '/';
    this.router.navigate(['/login', result.code, result.type, result.token], {
      queryParams: { returnUrl },
    });
  }

  public handleCancel() {
    this.router.navigate(['/login']);
  }

  public ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
